var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "url(#paint0_radial_1150_22299)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1150_22299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8625 14.8332C13.8625 14.8332 15.7325 14.9049 16.4617 14.5832C16.9703 14.353 17.4096 13.9932 17.7354 13.5398C18.0613 13.0864 18.2623 12.5554 18.3183 11.9999C18.4275 10.909 17.93 9.71069 16.99 9.13069C16.5225 8.84319 15.9767 8.72652 15.4308 8.67902C15.1194 8.6708 14.8078 8.68472 14.4983 8.72069C14.2829 8.03167 13.8674 7.42229 13.3047 6.97001C12.742 6.51773 12.0576 6.24298 11.3383 6.18069C10.778 6.14006 10.216 6.23294 9.69859 6.45168C9.18113 6.67043 8.72295 7.0088 8.36167 7.43902C8.00791 7.86202 7.75411 8.35936 7.61917 8.89402C7.58333 9.03569 7.5125 9.43069 7.5125 9.43069C7.14787 9.54796 6.8112 9.73885 6.52333 9.99152C5.6475 10.7749 5.43417 12.1132 5.92417 13.1665C6.36917 14.1232 7.325 14.8332 8.38833 14.8332H10.1383",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.854V18.7848",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.83325 13.1873L11.9999 10.854L14.1666 13.1873",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1150_22299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.024 30.288) rotate(-134.873) scale(49.7154 169.121)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2AA0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1150_22299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedUpload);
export default __webpack_public_path__ + "static/media/red-upload.92ba9489a06578cac5b72b5a79ce865c.svg";
export { ForwardRef as ReactComponent };